import utils from '../libs/utils';
import axios from './axios';

const BASE_URL = 'v1/erp-business-web';
export default {
  axios,
  // 应收库存列表
  receivableList(params) {
    return axios.post(`${BASE_URL}/receivable/stocktaking/plan/list/condition`,
      utils.exchangeParams(params));
  },
  // 录入页面详情接口
  getReceivableInputInfo(params) {
    return axios.get(`${BASE_URL}/receivable/stocktaking/input/info?${utils.exchangeParams(params)}`);
  },
  // 页面查看详情接口
  getReceivableCheckInfo(params) {
    return axios.get(`${BASE_URL}/receivable/stocktaking/plan/detail/info?${utils.exchangeParams(params)}`);
  },
  // 调整页面详情接口
  getReceivableAdjustInfo(params) {
    return axios.get(`${BASE_URL}/receivable/stocktaking/adjust/info?${utils.exchangeParams(params)}`);
  },
  // 录入保存接口
  saveReceivableInput(params) {
    return axios.post(`${BASE_URL}/receivable/stocktaking/input/save`,
      params);
  },
  // 录入提交接口
  submitReceivableInput(params) {
    return axios.post(`${BASE_URL}/receivable/stocktaking/input/submit`,
      params);
  },
  // 调整提交接口
  submitReceivableAdjust(params) {
    return axios.post(`${BASE_URL}/receivable/stocktaking/adjust/submit`, params);
  },
  // 调整查询收款单明细
  getAdjustDepositList(params) {
    return axios.post(`${BASE_URL}/receivable/stocktaking/adjust/finance/deposit/list`,
      params);
  },
  // 调整查询销售订单明细
  getAdjustSaleOrderList(params) {
    return axios.post(`${BASE_URL}/receivable/stocktaking/adjust/saleOrder/detail/list`,
      params);
  },
  // 导出
  exportAdjustSaleOrderList(params) {
    return axios.post(`${BASE_URL}/receivable/stocktaking/plan/detail/export`, utils.exchangeParams(params), {
      responseType: 'blob',
    });
  },
};
